import React, { useEffect, useState, useCallback } from 'react';
import { SpaceBetween, Box, Spinner } from '@cloudscape-design/components';
import { browse } from './browseClient';

/** The Continental's sports desk — live + final scores, league-filterable. */
const CLARET = '#7c2128';

function StatusPill({ g }) {
  if (g.state === 'live') {
    return (
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, color: CLARET, fontWeight: 700, fontSize: 11 }}>
        <span style={{ width: 6, height: 6, borderRadius: '50%', background: CLARET, display: 'inline-block' }} />
        LIVE {g.clock || ''}
      </span>
    );
  }
  if (g.state === 'final') return <span style={{ fontSize: 11, fontWeight: 700, color: '#8a7f70' }}>FINAL</span>;
  return <span style={{ fontSize: 11, color: '#8a7f70' }}>Upcoming</span>;
}

function TeamLine({ name, score, win }) {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8 }}>
      <span style={{ fontWeight: win ? 700 : 500, color: win ? CLARET : '#1a1714' }}>{name}</span>
      <span style={{ fontWeight: win ? 700 : 500, fontVariantNumeric: 'tabular-nums' }}>
        {score == null ? '–' : score}
      </span>
    </div>
  );
}

function GameCard({ g }) {
  const h = g.score?.home, a = g.score?.away;
  return (
    <div style={{
      border: `1px solid ${g.state === 'live' ? CLARET + '55' : '#e2dac9'}`,
      borderRadius: 10, padding: '10px 12px', background: '#fffdf8', minWidth: 220, flex: '1 1 220px',
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6 }}>
        <span style={{ fontSize: 11, color: '#a99e8c' }}>{g.emoji} {g.leagueName}</span>
        <StatusPill g={g} />
      </div>
      <TeamLine name={g.home.name} score={h} win={h != null && a != null && h > a} />
      <TeamLine name={g.away.name} score={a} win={h != null && a != null && a > h} />
    </div>
  );
}

export default function Scoreboard() {
  const [data, setData] = useState(null);
  const [league, setLeague] = useState('');
  const [loading, setLoading] = useState(true);

  const load = useCallback((lg) => {
    setLoading(true);
    browse.scores(lg).then(setData).catch(() => setData({ games: [], leagues: [] })).finally(() => setLoading(false));
  }, []);
  useEffect(() => { load(''); }, [load]);

  const liveCount = (data?.games || []).filter((g) => g.state === 'live').length;

  return (
    <SpaceBetween size="m">
      <div>
        <Box variant="h2"><span style={{ fontFamily: 'Georgia, serif' }}>Scores</span></Box>
        <Box fontSize="body-s" color="text-body-secondary">
          {liveCount > 0 ? `${liveCount} live now` : 'Latest results'} · paid lookups deliver full standings
        </Box>
      </div>

      <SpaceBetween direction="horizontal" size="xs">
        <button onClick={() => { setLeague(''); load(''); }}
          style={leagueBtn(!league)}>All</button>
        {(data?.leagues || []).map((l) => (
          <button key={l.id} onClick={() => { setLeague(l.id); load(l.id); }} style={leagueBtn(league === l.id)}>
            {l.emoji} {l.name}
          </button>
        ))}
      </SpaceBetween>

      {loading ? <Spinner /> : (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>
          {(data?.games || []).map((g) => <GameCard key={g.id} g={g} />)}
          {(data?.games || []).length === 0 && <Box color="text-body-secondary">No games.</Box>}
        </div>
      )}
    </SpaceBetween>
  );
}

function leagueBtn(active) {
  return {
    border: `1px solid ${active ? CLARET : '#d4dae3'}`,
    color: active ? '#fff' : '#1a1714',
    background: active ? CLARET : '#fff',
    borderRadius: 16, padding: '4px 12px', fontSize: 12, cursor: 'pointer', fontWeight: 600,
  };
}
